import React, { PureComponent } from "react";
import { ICSS, Color, ICSSProps, ColorProps, GlobalColorPalette } from "@gago/frame";
import styled from "styled-components";
// tslint:disable:variable-name jsx-no-multiline-js
const RadioSelectBody = styled.div<ColorProps<GlobalColorPalette>>`
  position: relative;
  padding: 0 16px;
  .title-box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .tb-label{
      height: 32px;
      line-height: 30px;
      width: 104px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #82e0ff;
      cursor: pointer;
      user-select: none;
      border: 1px solid rgb(0 202 224 / 60%);
      background-color: rgb(0 202 224 / 30%);
      transition: all 0.25s ease-out;
      box-sizing: border-box;
      margin-right: 10px;
      position: relative;
      &:hover{
        color: #ffcc00;
      }
      /* &::after{
        content: "";
        position: absolute;
        right: -6px;
        top: 10px;
        height: 12px;
        width: 2px;
        background-color: rgb(0 202 224 / 20%);
      } */
      &:last-child{
        margin-right: 0;
        /* &::after{
          display: none;
        } */
      }
    }
    .tb-value{
      color: #ffcc00;
      background-color: rgb(255 160 51 / 30%);
      border-color: rgb(255 160 51 / 60%);
      &::after{
        content: "";
        position: absolute;
        z-index: 22;
        bottom: -1px;
        left: 0px;
        height: 1px;
        width: 100%;
        background-color:  rgba(27, 83, 147, 0);
        background-image: radial-gradient(circle at 50% 50%, rgb(255, 255, 255), rgba(27, 83, 147, 0) 66%), linear-gradient(#f57f45, #f57f45);
      }
    }
  }
`;

type Rprops = {
  /** 展示数据 */
  // tslint:disable-next-line:completed-docs
  data: {label: string; value: string}[];
  /** 选择类型返回事件 */
  backSelectChange?(type: string): void;
  /** 默认选择 */
  defaultValue?: string;
  /** 选择的值 */
  value?: string;
} & ICSSProps & ColorProps<GlobalColorPalette>;
interface Rstate {
  /** 选择的类型 */
  selectValue: string;
}
/**
 * 单选选择框  简单版
 * @author 马俊峰
 * @date 2020-06-24
 * @export
 * @class RadioSelect
 * @extends {PureComponent<Rprops>}
 * @implements {ICSS}
 * @implements {Color}
 */
export class RadioSelectSimple extends PureComponent<Rprops, Rstate> implements ICSS, Color {
  state: Rstate = {
    selectValue: "",
  };
  componentDidMount() {
    const { defaultValue, data } = this.props;
    if (defaultValue) { this.setState({ selectValue: defaultValue }); } else {
      this.setState({ selectValue: data[0] && data[0].value || "" });
    }
  }
  componentDidUpdate(preProps: Rprops) {
    if (this.props.value !== preProps.value) {
      this.setState({ selectValue: this.props.value || "" });
    }
  }
  render() {
    const { colorPalette, style, className, data } = this.props;
    const { selectValue } = this.state;
    return(
      <RadioSelectBody colorPalette={colorPalette} style={style} className={className}>
        <div className="title-box">
          {data.map((item, index) => (
            <span
              className={`tb-label ${selectValue === item.value ? "tb-value" : ""}`}
              key={index}
              onClick={this.mapBaseTypeSelect.bind(this, item.value)}
            >
              {item.label}
            </span>
          ))}
        </div>
      </RadioSelectBody>
    );
  }
  /** 选择事件 */
  mapBaseTypeSelect = (type: string) => {
    this.setState({ selectValue: type });
    this.props.backSelectChange && this.props.backSelectChange(type);
  }
}
